export default __webpack_public_path__ + "static/media/fad-v-expand.45da4123.svg";